export const optionStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  minWidth: 0,
};
